module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="apexChat_ep_poke_msg_container">\r\n    <div class="apexChat_ep_poke_timestamp">' +
((__t = (msgTimeStamp)) == null ? '' : __t) +
'</div>\r\n    <div class="apexChat_ep_poke_msg">' +
((__t = (text)) == null ? '' : __t) +
'</div>\r\n</div>\r\n';

}
return __p
}